<template>
  <ul>
    <li
      class="pl-4 mb-3"
      :class="{
        active: isActive(['registrations'], ['edit', 'update'])
      }"
    >
      <a href="/users/edit">
        {{ t('edit_profile') }}
      </a>
    </li>
    <li
      class="pl-4 mb-3"
      :class="{
        active: isActive(['registrations'], ['edit_profile_email', 'change_profile_email'])
      }"
    >
      <a
        class="text-dark-gray"
        href="/users/profile/edit_email"
      >
        {{ t('edit_email') }}
      </a>
    </li>
    <li
      class="pl-4 mb-3"
      :class="{
        active: isActive(['registrations'], ['edit_profile_password', 'change_profile_password'])
      }"
    >
      <a
        class="text-dark-gray"
        href="/users/profile/edit_password"
      >
        {{ t('edit_password') }}
      </a>
    </li>
    <li
      class="pl-4 mb-3"
      :class="{
        active: isActive(['email_preferences'], ['index'])
      }"
    >
      <a
        class="text-dark-gray"
        href="/admin/email_preferences"
      >
        {{ t('email_notification_preferences') }}
      </a>
    </li>
    <li
      v-if="isMainAccount"
      class="pl-4 mb-3"
      :class="{
        active: isActive(['registrations'], ['quit', 'cancel_membership_application'])
      }"
    >
      <a
        class="text-dark-gray"
        href="/users/quit"
      >
        {{ t('cancel_membership_application') }}
      </a>
    </li>
    <li class="pl-4 mb-3">
      <a
        href="/users/sign_out"
        class="text-dark-gray"
        data-method="delete"
      >
        {{ t('sign_out') }}
      </a>
    </li>
  </ul>
</template>

<script>
import "../i18n/ja";
import { i18n } from "../mixins/i18n";

export default {
  mixins: [i18n],
  props: {
    isMainAccount: {
      type: Boolean,
      default: false
    },
    controllerName: {
      type: String,
      default: ""
    },
    actionName: {
      type: String,
      default: ""
    }
  },
  methods: {
    isActive(controllers, actions) {
      return controllers.includes(this.controllerName) && actions.includes(this.actionName);
    }
  }
};
</script>

<style lang="scss" scoped>
ul {
  li a {
    line-height: 30px;
    color: #495057;
  }
  li.active {
    border-left: 3px solid #0080FC;

    a {
      margin-left: -3px;
      color: #0080FC !important;
    }
  }
}
</style>
